import { _ as _extends } from '../../_rollupPluginBabelHelpers-mO86zOh3.js';
import { forwardRef } from 'react';
import { themed } from '@indeed/ifl-css';
import { Close } from '@indeed/ifl-icons';
import { StyledNotificationBase, StyledNotificationBody, NotificationTitle, StyledNotificationIcon, StyledNotificationContent } from '../Alert/styles.js';
import { jsx } from '@emotion/react';
export { NOTIFICATION_TYPES as TOAST_TYPES } from '../Alert/types.js';
import { Button } from '../Button/Button.js';
import { LiveRegion } from '../LiveRegion/LiveRegion.js';
import { icons } from '../Alert/Alert.js';
import '../../utils/transition.js';
import '../../utils/styled.js';
import '../../constants/index.js';
import '../../utils/createResponsive.js';
import '../../utils/transparentize.js';
import '../Button/context.js';
import '../Spinner/Spinner.js';
import '@indeed/ihl-use-id';
import '../IconWrapper/IconWrapper.js';
import '../VisuallyHidden/VisuallyHidden.js';

const statuses = {
  info: {
    [`${StyledNotificationIcon}`]: {
      color: "foreground.status.info"
    },
    [`${NotificationTitle}`]: {
      color: "foreground.status.info"
    }
  },
  success: {
    [`${StyledNotificationIcon}`]: {
      color: "foreground.status.success"
    },
    [`${NotificationTitle}`]: {
      color: "foreground.status.success"
    }
  },
  warning: {
    [`${StyledNotificationIcon}`]: {
      color: "foreground.status.warning"
    },
    [`${NotificationTitle}`]: {
      color: "foreground.status.warning"
    }
  },
  critical: {
    [`${StyledNotificationIcon}`]: {
      color: "foreground.status.critical"
    },
    [`${NotificationTitle}`]: {
      color: "foreground.status.critical"
    }
  }
};
const StyledToast = /*#__PURE__*/themed(StyledNotificationBase, process.env.NODE_ENV === "production" ? {
  styleProps: ["status"],
  shouldForwardProp: prop => prop !== "status",
  target: "e171e7gg0"
} : {
  styleProps: ["status"],
  shouldForwardProp: prop => prop !== "status",
  target: "e171e7gg0",
  label: "StyledToast"
})(_ref => {
  let {
    status = "info"
  } = _ref;
  return {
    display: "flex",
    alignItems: "flex-start",
    overflowWrap: "anywhere",
    columnGap: 1,
    paddingBlockStart: 4,
    paddingBlockEnd: 4,
    paddingInlineStart: 4,
    paddingInlineEnd: 4,
    inlineSize: "100%",
    maxInlineSize: "380px",
    color: "foreground.strong",
    bg: "background",
    borderRadius: "lg",
    boxShadow: "high",
    ...statuses[status],
    [`${StyledNotificationBody}`]: {
      flex: "1 1 auto",
      // Only the "body" of the toast should fill the available space.
      alignSelf: "center",
      paddingInlineStart: 2,
      paddingInlineEnd: 3
    }
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");

/**
 * @see https://experience.indeed.design/components/ids/toast
 */
const Toast = /*#__PURE__*/forwardRef((_ref2, ref) => {
  let {
    children,
    dismissProps = {
      "aria-label": "Close"
    },
    icon,
    onDismiss,
    status = "info",
    type = "polite",
    ...props
  } = _ref2;
  const Icon = icon === undefined ? icons[status] : icon;
  const AnnounceableContent = jsx(StyledNotificationContent, {
    sx: {
      paddingBlockStart: 0,
      paddingBlockEnd: 0
    }
  }, children);
  const ToastContent = type ? jsx(LiveRegion, {
    type: type
  }, AnnounceableContent) : AnnounceableContent;
  return jsx(StyledToast, _extends({
    ref: ref,
    status: status,
    role: "group"
  }, props), Icon && jsx(StyledNotificationIcon, {
    sx: {
      display: "flex",
      marginBlockStart: 0,
      paddingBlockStart: 0,
      paddingInlineEnd: 0
    }
  }, Icon), jsx(StyledNotificationBody, {
    sx: {
      marginBlockStart: "0.125rem"
    }
  }, ToastContent), onDismiss && jsx(Button, _extends({
    iconOnly: true,
    sx: {
      flex: "0 0 auto",
      marginBlockStart: "-sc2",
      marginInlineEnd: "-sc2",
      marginBlockEnd: "-sc2"
    },
    variant: "tertiary",
    size: "sm",
    onClick: onDismiss
  }, dismissProps), jsx(Close, {
    "aria-hidden": true
  })));
});
const TOAST_STATUSES = Object.keys(statuses);
Toast.displayName = "Toast";

export { TOAST_STATUSES, Toast, NotificationTitle as ToastTitle };
